import api from './api';

export interface LoaiGiayToDto {
  maLoaiGiayTo: number;
  tenLoai: string;
  moTa: string | null;
  batBuoc: boolean;
  canhBaoHetHan: boolean;
  thuTuHienThi: number | null;
  active: boolean;
}

export interface GiayToDto {
  id: number;
  maChamCong: string;
  tenNV: string | null;
  maKK: number | null;
  tenKhoa: string | null;
  maLoaiGiayTo: number;
  tenLoai: string | null;
  ten: string;
  maSo: string | null;
  noiCap: string | null;
  ngayCap: string | null;
  ngayHetHan: string | null;
  tenFileGoc: string;
  tenFileLuuTru: string;
  duongDan: string;
  loaiFile: string;
  dungLuong: number | null;
  ghiChu: string | null;
  ngayTao: string;
  nguoiTao: string | null;
  ngayCapNhat: string | null;
  nguoiCapNhat: string | null;
  active: boolean;
}

export interface CreateLoaiGiayToRequest {
  tenLoai: string;
  moTa?: string | null;
  batBuoc: boolean;
  canhBaoHetHan: boolean;
  thuTuHienThi?: number | null;
}

export interface UpdateLoaiGiayToRequest {
  tenLoai: string;
  moTa?: string | null;
  batBuoc: boolean;
  canhBaoHetHan: boolean;
  thuTuHienThi?: number | null;
  active: boolean;
}

export interface CreateGiayToRequest {
  maChamCong: string;
  maLoaiGiayTo: number;
  ten: string;
  maSo?: string | null;
  noiCap?: string | null;
  ngayCap?: string | null;
  ngayHetHan?: string | null;
  ghiChu?: string | null;
}

export interface UpdateGiayToRequest {
  maLoaiGiayTo: number;
  ten: string;
  maSo?: string | null;
  noiCap?: string | null;
  ngayCap?: string | null;
  ngayHetHan?: string | null;
  ghiChu?: string | null;
}

export interface NhanVienAnhDaiDienDto {
  maChamCong: string;
  tenFileGoc: string;
  tenFileLuuTru: string;
  duongDan: string;
  loaiFile: string;
  dungLuong: number | null;
  ngayTao: string;
  nguoiTao: string | null;
  ngayCapNhat: string | null;
  nguoiCapNhat: string | null;
}

export const hoSoNhanVienService = {
  // LoaiGiayTo
  getLoaiGiayToList: () => api.get<LoaiGiayToDto[]>('/hoso-nhan-vien/loai-giay-to'),
  getLoaiGiayTo: (id: number) => api.get<LoaiGiayToDto>(`/hoso-nhan-vien/loai-giay-to/${id}`),
  createLoaiGiayTo: (data: CreateLoaiGiayToRequest) => api.post('/hoso-nhan-vien/loai-giay-to', data),
  updateLoaiGiayTo: (id: number, data: UpdateLoaiGiayToRequest) => api.put(`/hoso-nhan-vien/loai-giay-to/${id}`, data),
  deleteLoaiGiayTo: (id: number) => api.delete(`/hoso-nhan-vien/loai-giay-to/${id}`),

  // GiayTo
  getGiayToList: (maChamCong?: string, maLoaiGiayTo?: number) =>
    api.get<GiayToDto[]>('/hoso-nhan-vien/giay-to', { params: { maChamCong, maLoaiGiayTo } }),
  getPendingGiayToList: (maChamCong?: string, maLoaiGiayTo?: number) =>
    api.get<GiayToDto[]>('/hoso-nhan-vien/giay-to/pending', { params: { maChamCong, maLoaiGiayTo } }),
  getGiayTo: (id: number) => api.get<GiayToDto>(`/hoso-nhan-vien/giay-to/${id}`),
  createGiayTo: (data: CreateGiayToRequest, file: File) => {
    const formData = new FormData();
    formData.append('maChamCong', data.maChamCong);
    formData.append('maLoaiGiayTo', data.maLoaiGiayTo.toString());
    formData.append('ten', data.ten);
    if (data.maSo) formData.append('maSo', data.maSo);
    if (data.noiCap) formData.append('noiCap', data.noiCap);
    if (data.ngayCap) formData.append('ngayCap', data.ngayCap);
    if (data.ngayHetHan) formData.append('ngayHetHan', data.ngayHetHan);
    if (data.ghiChu) formData.append('ghiChu', data.ghiChu);
    formData.append('file', file);
    return api.post('/hoso-nhan-vien/giay-to', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  updateGiayTo: (id: number, data: UpdateGiayToRequest) =>
    api.put(`/hoso-nhan-vien/giay-to/${id}`, data),
  replaceGiayToFile: (id: number, file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.put(`/hoso-nhan-vien/giay-to/${id}/replace-file`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  deleteGiayTo: (id: number) => api.delete(`/hoso-nhan-vien/giay-to/${id}`),
  approveGiayTo: (id: number) => api.put(`/hoso-nhan-vien/giay-to/${id}/approve`),

  // File (fetch blob qua axios để mang theo token trong header)
  getPreviewBlob: async (id: number): Promise<Blob> => {
    const res = await api.get(`/hoso-nhan-vien/giay-to/${id}/preview`, { responseType: 'blob' });
    return res.data;
  },
  getDownloadBlob: async (id: number): Promise<Blob> => {
    const res = await api.get(`/hoso-nhan-vien/giay-to/${id}/download`, { responseType: 'blob' });
    return res.data;
  },

  // AnhDaiDien
  getAnhDaiDien: (maChamCong: string) =>
    api.get<NhanVienAnhDaiDienDto | null>(`/hoso-nhan-vien/anh-dai-dien/${maChamCong}`),
  uploadAnhDaiDien: (maChamCong: string, file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/hoso-nhan-vien/anh-dai-dien/${maChamCong}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  deleteAnhDaiDien: (maChamCong: string) =>
    api.delete(`/hoso-nhan-vien/anh-dai-dien/${maChamCong}`),
  getAnhDaiDienPreviewBlob: async (maChamCong: string): Promise<Blob> => {
    const res = await api.get(`/hoso-nhan-vien/anh-dai-dien/${maChamCong}/preview`, { responseType: 'blob' });
    return res.data;
  },
  getAnhDaiDienDownloadBlob: async (maChamCong: string): Promise<Blob> => {
    const res = await api.get(`/hoso-nhan-vien/anh-dai-dien/${maChamCong}/download`, { responseType: 'blob' });
    return res.data;
  },
};

// UserProfile service - endpoints cho user profile view (chỉ cần đăng nhập, không cần permission đặc biệt)
export const userProfileService = {
  // LoaiGiayTo (Read-only)
  getLoaiGiayToList: () => api.get<LoaiGiayToDto[]>('/user-profile/loai-giay-to'),
  getLoaiGiayTo: (id: number) => api.get<LoaiGiayToDto>(`/user-profile/loai-giay-to/${id}`),

  // GiayTo
  getGiayToList: (maChamCong?: string, maLoaiGiayTo?: number) =>
    api.get<GiayToDto[]>('/user-profile/giay-to', { params: { maChamCong, maLoaiGiayTo } }),
  getGiayToListIncludingPending: (maChamCong?: string, maLoaiGiayTo?: number) =>
    api.get<GiayToDto[]>('/user-profile/giay-to/all', { params: { maChamCong, maLoaiGiayTo } }),
  getGiayTo: (id: number) => api.get<GiayToDto>(`/user-profile/giay-to/${id}`),
  createGiayTo: (data: CreateGiayToRequest, file: File) => {
    const formData = new FormData();
    formData.append('maChamCong', data.maChamCong);
    formData.append('maLoaiGiayTo', data.maLoaiGiayTo.toString());
    formData.append('ten', data.ten);
    if (data.maSo) formData.append('maSo', data.maSo);
    if (data.noiCap) formData.append('noiCap', data.noiCap);
    if (data.ngayCap) formData.append('ngayCap', data.ngayCap);
    if (data.ngayHetHan) formData.append('ngayHetHan', data.ngayHetHan);
    if (data.ghiChu) formData.append('ghiChu', data.ghiChu);
    formData.append('file', file);
    return api.post('/user-profile/giay-to', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  updateGiayTo: (id: number, data: UpdateGiayToRequest) =>
    api.put(`/user-profile/giay-to/${id}`, data),
  replaceGiayToFile: (id: number, file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.put(`/user-profile/giay-to/${id}/replace-file`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  getPreviewBlob: async (id: number): Promise<Blob> => {
    const res = await api.get(`/user-profile/giay-to/${id}/preview`, { responseType: 'blob' });
    return res.data;
  },
  getDownloadBlob: async (id: number): Promise<Blob> => {
    const res = await api.get(`/user-profile/giay-to/${id}/download`, { responseType: 'blob' });
    return res.data;
  },

  // AnhDaiDien (Read-only)
  getAnhDaiDien: (maChamCong: string) =>
    api.get<NhanVienAnhDaiDienDto | null>(`/user-profile/anh-dai-dien/${maChamCong}`),
  getAnhDaiDienPreviewBlob: async (maChamCong: string): Promise<Blob> => {
    const res = await api.get(`/user-profile/anh-dai-dien/${maChamCong}/preview`, { responseType: 'blob' });
    return res.data;
  },
  getAnhDaiDienDownloadBlob: async (maChamCong: string): Promise<Blob> => {
    const res = await api.get(`/user-profile/anh-dai-dien/${maChamCong}/download`, { responseType: 'blob' });
    return res.data;
  },
};
